import axios from 'api';

export const getIssuesList = async ({ page, pageSize, search, startDate, endDate }) => {
  return axios.get(`api/elastic/help?page=${page}&page_size=${pageSize}&search=${search}&start_date=${startDate}&end_date=${endDate}`);
};

export const getIssueDataByKey = async ({ key }) => {
  return axios.get(`api/elastic/help/${key}/`);
};

export const createIssue = async (params) => {
  return axios.post(`api/elastic/help`, params);
};

export const deleteIssue = async ({ id }) => {
  return axios.delete(`api/elastic/help/${id}/`);
};

export const addAttachments = async (params) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };
  return axios.post(`api/elastic/help_attachment`, params, config);
};

export const downloadAttachments = async ({ id }) => {
  return axios.get(`api/elastic/help_download_attachment?attachment_id=${id}`, {
    responseType: 'blob'
  });
};
